let msgCounter = 0;

export function msgId(prefix: string) {
  return `${prefix}_${++msgCounter}_${Date.now()}`;
}

export function nowIso() {
  return new Date().toISOString();
}
